const MESSAGES_KEY = "__messages";

const getMessagesFormStore = () => {
  let messages = {};

  try {
    const messagesString = localStorage.getItem(MESSAGES_KEY);
    messages = messagesString && messagesString !== null && messagesString !== "undefined" ? JSON.parse(messagesString) : {};
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  }

  return messages;
};

const setMessageInStore = message => {
  const messages = getMessagesFormStore();
  const {
    id
  } = message;
  localStorage.setItem(MESSAGES_KEY, JSON.stringify({ ...messages,
    [id]: { ...message
    }
  }));
};

export { setMessageInStore };